<template>
  <section id="space" itemscope class="bg-grey radius-big t-black">

    <div class="gap-zero pos-relative cols-2">
    	<!-- Right col -->
      <aside  class="w-100 h-100 gap-small  pd-thin">
      
        <div  style="min-height: 30rem" class="h-100 mn-b-small pos-relative">
            <img class="object-fit-cover radius-big o-hidden pos-absolute h-100 w-100" src="/pictures/photo_6.jpg" itemprop="contentUrl">
        </div>

    <!--     <div style="min-height: 40rem" class="h-33 w-100 pos-relative gap-small cols-3">
          <div class="h-100 pos-relative">
            <img class="object-fit-cover radius-big o-hidden  pos-absolute h-100 w-100" src="/pictures/photo_5.jpg" itemprop="contentUrl">
          </div>
          <div class="h-100 pos-relative">
              <img class="object-fit-cover radius-big o-hidden pos-absolute h-100 w-100" src="/pictures/photo_9.jpg" itemprop="contentUrl" :alt="$t('map.first_image_alt')">
          </div>
          	<div @click="$router.push({name: 'Gallery'})" class="h-100 radius-big o-hidden t-semi h4 uppercase bg-main pd-medium hover-scale-1 h-100 w-100">
					{{$t('space.goToGallery')}}
				</div>
        </div> -->
       
     	</aside>
			
      <!-- Left col -->
       <article class="pd-big flex-column flex-nowrap flex col-2 col" itemprop="description">
					<p class="mn-b-small t-transp h4">
						<span class="text-fade-in">
		          <span class="text-splitted">{{$t('space.offers')}}</span>
		      	</span>
					</p>

					<h2 class="mn-b-big">
						<span class="text-fade-in">
		          <span class="text-splitted">{{$t('space.beautifulPlace')}}</span>
		      	</span>
					</h2> 

					<p class="mn-b-medium p-big">{{$t('space.partyVenueDescription')}}</p>

					<p class="t-transp mn-b-medium p-medium">{{$t('space.relaxedAtmosphereDescription')}}</p>

				 	

					<div class="rent-button w-100 radius-small br-black-transp br-1px br-solid flex-v-center flex-justify pd-small flex">
						<p class="mn-r-auto uppercase">{{$t('space.bookTheCommune')}}</p>
						<a href="https://t.me/thecommunebar" target="_blank" class="t-main uppercase">{{$t('space.bookNow')}}</a>
					</div>
      </article>
    </div>
  </section>
</template>

<script setup>
</script>